import * as React from "react";
import { Button, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link as RouterLink } from "react-router";

interface BrowsingSubbarProps {
  title: string;
  start: React.ReactElement;
  end: React.ReactElement;
}

const BrowsingSubbar: React.FC<BrowsingSubbarProps> = (props) => {
  const { title, start, end } = props;
  return (
    <>
      <Stack direction="row" alignItems="center">
        <Button component={RouterLink} to="/">
          <ArrowBackIcon />
        </Button>
        <Typography variant="h5" component="h1" ml={1} mr={2}>
          {title}
        </Typography>
        {start}
      </Stack>
      <Stack direction="row" alignItems="center" spacing={2}>
        {end}
      </Stack>
    </>
  );
};

export default BrowsingSubbar;
